import { css } from '@emotion/css'

export const container = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
`

export const listContainer = css`
  display: flex;
  flex-direction: column;
`

export const previewItem = css`
  flex: 1;
  margin: 0 10px;
`

export const previewImgHandle = css`
  max-width: 500px;
`